import { inject, Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { _, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { PermissionName } from '@app/core/permissions/enums/permission-name.enum';
import { IPipePolyline } from '@app/main/main-content/map/interfaces/pipe-polyline.interface';
import { contextMenuTodo } from '@app/main/main-content/context-menu/utils/context-menu-todo';

@Injectable({ providedIn: 'root' })
export class LdContextMenuPipeService {
  private readonly translateService = inject(TranslateService);
  private readonly ngxPermissionsService = inject(NgxPermissionsService);

  public getMapItems(pipe: IPipePolyline): MenuItem[] {
    if (!this.canAccessPipe()) return [];

    const deleteSegmentItems: MenuItem[] = this.canDeleteSegment()
      ? [
          {
            label: this.translateService.instant(_(`@@leak-detection-context-menu-delete-segment__label`)),
            icon: 'icons/icon-delete.svg',
            command: () => contextMenuTodo('Delete segment', pipe),
          },
        ]
      : [];

    return [
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-edit-pipe-on-map__label`)),
        icon: 'icons/icon-edit-pipe-on-map.svg',
        command: () => contextMenuTodo('Edit pipe on map', pipe),
      },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-edit-segment-parameters__label`)),
        icon: 'icons/icon-edit-segment-parameters.svg',
        command: () => contextMenuTodo('Edit segment parameters', pipe),
      },
      ...deleteSegmentItems,
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-create-pipe__label`)),
        icon: 'icons/icon-create-pipe.svg',
        command: () => contextMenuTodo('Create pipe', pipe),
      },
      { separator: true },
      {
        label: this.translateService.instant(_(`@@leak-detection-context-menu-open-pipes-editor__label`)),
        icon: 'icons/icon-pipes-editor.svg',
        command: () => contextMenuTodo('Open pipes editor', pipe),
      },
    ];
  }

  private canAccessPipe(): boolean {
    return !!this.ngxPermissionsService.getPermission(PermissionName.LeakDetection_Read_PipeContextMenu);
  }

  private canDeleteSegment(): boolean {
    return !!this.ngxPermissionsService.getPermission(PermissionName.LeakDetection_Write_PipeSegmentDelete);
  }
}
